import { Route, Routes } from 'react-router-dom';
import { BlogsPage } from './BlogsPage';
import { ModifyBlogPage } from './ModifyBlogPage';

export const BlogPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyBlogPage />} />
    <Route path='/:slug' element={<ModifyBlogPage />} />
    <Route path='*' element={<BlogsPage />} />
  </Routes>
);
